import { Component } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import {SettingsService} from 'src/app/services/settings.service'
import { Router ,ActivatedRoute} from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { Subscription } from 'rxjs';
import {PaymentConfigService}  from 'src/app/services/payment-config.service'
import {AirManagementService}  from 'src/app/services/air-management.service'
import { Observable } from 'rxjs/internal/Observable';
import { City, Country, State, StaticdataService } from 'src/app/services/staticdata.service';
import { CustomValidatorsService } from 'src/app/services/custom-validators.service';
import { map } from 'rxjs/internal/operators/map';
import { startWith } from 'rxjs/internal/operators/startWith';
import { DataService } from 'src/app/services/data.service';
import {CartService} from 'src/app/services/cart.service';
import { FlightService } from 'src/app/services/flight.service';
import { UserService } from 'src/app/services/user.service';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { UserInfo, UserInfoService } from 'src/app/services/user-info.service';

@Component({
  selector: 'app-pnr-retrive',
  templateUrl: './pnr-retrive.component.html',
  styleUrls: ['./pnr-retrive.component.css']
})
export class PnrRetriveComponent {

  showPnrRetrieval:boolean=false
  pnrRegFg!:FormGroup



 
  id:any
  tokenData:any={
    userType:'',
    username:'',
    userUuid:'',
    name:'',
  }
  constructor(private FlightService:FlightService,private CartService:CartService, private data:DataService, private route :ActivatedRoute,private staticDataService : StaticdataService,private customValidator : CustomValidatorsService,private SettingsService:SettingsService,private router:Router,private location:Location,private fb : FormBuilder,    private toastMsgService : ToastmsgService,
    private PaymentConfigService:PaymentConfigService,private AirManagementService:AirManagementService,private UserService:UserService,private userInfoService : UserInfoService,){

      this.tokenData.userType=userInfoService.getUserType();
  this.tokenData.userType=this.tokenData.userType.toUpperCase()

  this.tokenData.username=userInfoService.getUsername();
  this.tokenData.userUuid=this.userInfoService.getUserUuid()


      this.tokenData.name=this.userInfoService.getUserDisplayname();
      if(this.tokenData.userType==='CORPORATE'||this.tokenData.userType==='AGENT'){
        this.userName={
          name:this.tokenData.name,
          userUid:this.tokenData.userUuid,
          username:this.tokenData.username
    
        }
      }
      this.supplierlist()
      this.getFlightList()
      this.getUsersList()
  //  this.route.queryParams.subscribe(params => {
  //   let data:any
  //   data=params
  //   this.id=this.decodeTransformedcode(data.id)
   
  //  // for(let i=0 ;i <data.length; i++){ this.email +=data[i]; }
    
    
  
  //     });
  this.dataFields()

   this.onClickRetrieval()
    }
    ngOnInit(): void  {
      
    }

    dataFields(){
      this.pnrRegFg=this.fb.group({
        "source" :  [''],
        "supplier" : [''],
        "pnrNumber":[''],
      
      });
    }
    decodeTransformedcode(encodedEmail: string): string {
      let result = '';
    
      for (let i = 0; i < encodedEmail.length; i += 2) {
        const hexChar = encodedEmail.slice(i, i + 2);
        const charCode = parseInt(hexChar, 16); // Convert the hexadecimal string to a character code
        result += String.fromCharCode(charCode);
      }
    
      return result;
    }

    supplierList:any
    supplierlist(){
     
      this.AirManagementService
      .supplierlist()
      .subscribe({
        next : (res:any) => {
          if(res) {
         let data:any=[]
         data=res
         
        this.supplierList=data;
        this.sourceCodelist()

          } else {
          
          } 
        },error : (err) => {
  
        }
        
      }
      
    )
    }

 
  
  

  backClick(){
   // window.location.href="/app/settings"
   this.location.back()

      } 
     


      
      formatDate(val: Date) {
        let convertedValue:any = ""
        if(val){
        let datepipe = new DatePipe("en");
        //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
        convertedValue =  datepipe.transform(val, "dd-MM-yyyy hh:mm:ssa");
        }
        return convertedValue;
      }
     
   pnrData:any
   disabled:boolean=false
      AddCart(){
        this.disabled=true
      let request:any={   
          "routeRequest": {
             "source":this.pnrRegFg.value.source,
             "supplier":this.pnrRegFg.value.supplier
          },
          "pnrNumber": this.pnrRegFg.value.pnrNumber
      } 
    
        this.CartService.saveManularCart(request)
        .subscribe({
          next : (res) => {
            this.disabled=false

            console.log(res)
            if(res.status==200 || res.status==201) {
              this.toastMsgService.setMsg({msg : "Retrieve PNR Successfully!",msgTitle : "Success", msgType : "I"});
              // this.dataFields()
              this.showPnrRetrieval=true
              this.pnrData=res['body']
              this.pnrData.username=this.userName
              console.log(this.pnrData)
              this.pnrData.source=request?.routeRequest?.source
              this.pnrData.supplier=request?.routeRequest?.supplier

              this.data.deliverMsg(this.pnrData)

              sessionStorage.setItem('retrivePnr','true')

            } else {
              const body : any = res.body;
              this.registercreditCardErrorMsg(res.status,body?.result);
            } 
    
          },error : (err) => {
            this.disabled=false

            this.registercreditCardErrorMsg(err.status,err.error);
          }
        }
      )
    }
    
    registercreditCardErrorMsg(status : number,msg : string) {
      if(status >=500) {
        this.toastMsgService.setMsg({msg : "Failed to Retrieve",msgTitle : "Warning", msgType : "W"});
      } else {
    
        this.toastMsgService.setMsg({msg : "Failed to Retrieve",msgTitle:  "Warning", msgType : "W"});
      } 
    }

    
   

      Grouplist(){

        this.AirManagementService
        .grouplist()
        .subscribe({
          next : (res:any) => {
            if(res) {
              let data=res
           
            } else {
            
            } 
          },error : (err) => {
    
          }
        }
      )
      }
     
      onlyNumberKey(event:any) {
     
        let charCode = (event.which) ? event.which : event.keyCode;
        if (charCode != 46 && charCode > 31
            && (charCode < 48 || charCode > 57))
            return false;
        return true;
      }
  
              


    onClickRetrieval(){
      // this.showPnrRetrieval=true
    }
    sourceCodeList:any=[]
    filterSourceList:any=[]
    sourceCodelist(){
    
      this.AirManagementService
      .sourcelist()
      .subscribe({
        next : (res:any) => {
          if(res) {
         let data=res
         this.sourceCodeList=data
         
if(this.tokenData.userType==='AGENT'){
  let code:any=['32','33']
  let sourceCode=this.sourceCodeList?.filter((item:any)=>code.includes(item.code))
  let supplier:any=[]
  for(let source of sourceCode){
    supplier.push(source.supplierCode)
  }
  this.supplierList=this.supplierList?.filter((item:any)=>supplier.includes(item.code))
}
         
          } else {
          
          } 
        },error : (err) => {
    
        }
      }
    )
    }
    onClickSupplier(element:any){
      console.log(element.value)
      console.log(this.sourceCodeList)
      
      this.filterSourceList=this.sourceCodeList.filter((item:any)=>item.supplierCode===element.value)
      console.log( this.filterSourceList)
    }
    
    dateFormate(date:any){

      const parsedDate = new Date(date);
      const datePipe = new DatePipe('en-IN');
      date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
      // date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
    return date
    
    }
    flightList:any
    getFlightList(){
   
      this.FlightService
      .getFlightList()
      .subscribe({
        next : (res:any) => {
          if(res) {
           let data:any
           data=res  
           this.flightList=data
       
          } else {    
          } 
        },error : (err) => {
  
          
        }
      }
    )
    }
    cityFilter(item:any){
    

      if(item && this.flightList){
       
    
        item=this.flightList.filter((itm: { iataCode: any; })=>itm.iataCode === item)
    
      item=item[0]?.city
    
    return item}else{
      return item
    }
    }

    suggestions: any[] = [];
filteredUser: any[] = [];
userName:any
searchList(event: AutoCompleteCompleteEvent) {
  let filtered: any[] = [];
    let query = event.query;
console.log(event.originalEvent)
    for (let i = 0; i < (this.suggestions as any[]).length; i++) {
        let user = (this.suggestions as any[])[i];
        if (user.name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
            filtered.push(user);
        }
    }

    this.filteredUser = filtered;
}
getUsersList(){
  let userType:any
      this.UserService.getUserList('')
      .subscribe({
        next : (res:any) => {
          if(res) {
           // console.log(res)
          let  data:any;
          data=res["result"]
          this.suggestions=data
          // for (let i = 0; i < data.length; i++) {
            
          //   this.whereTo.push(data[i]?.name);

          // }
   
        }else{

        }},error : (err) => {
    
          console.error("Error in fetching data");
        }
      }
    )
    
  }
  GetChildData()
  {
    this.showPnrRetrieval=false
  }
}
